import type { ReportStudentRow } from '../../../api/types';
import HistogramChart from '../../../components/charts/HistogramChart';
import { PanelCard } from '../../../components/ui';

/** Counts per 10-point bucket ("0", "10" … "90"); a score of 100 lands in the top bucket. */
export function bucketScores(scores: number[]): Array<{ bucket: string; count: number }> {
  const counts = Array.from({ length: 10 }, () => 0);
  for (const s of scores) {
    if (!Number.isFinite(s)) continue;
    counts[Math.min(9, Math.max(0, Math.floor(s / 10)))] += 1;
  }
  return counts.map((count, i) => ({ bucket: String(i * 10), count }));
}

/** Design `.key` swatch + label for the legend. */
function Key({ className, children }: { className: string; children: string }) {
  return (
    <span className="flex items-center gap-1.5">
      <span aria-hidden="true" className={`inline-block h-2.5 w-2.5 rounded-[3px] ${className}`} />{children}
    </span>
  );
}

export default function ScoreDistributionCard({ students, passPct, sectionLabel = 'all sections' }: {
  students: ReportStudentRow[]; passPct: number; sectionLabel?: string;
}) {
  const buckets = bucketScores(students.flatMap((s) => (s.score == null ? [] : [s.score])));
  return (
    <PanelCard
      title="Score distribution"
      subtitle={`Students by score band · ${sectionLabel}`}
      actions={
        <span className="flex gap-3.5 text-xs text-muted">
          <Key className="bg-accent">Below pass</Key>
          <Key className="bg-slate-ink">Pass</Key>
        </span>
      }
    >
      <HistogramChart buckets={buckets} height={180} passPct={passPct} showValues />
    </PanelCard>
  );
}
